import { NO, UITextView, UIView } from "uicore-ts"
import { RHContractingAuthorityRules } from "../../ContractingAuthorityRules"
import { RHCheckbox } from "../../Custom components/RH/RHCheckbox"
import { RHColors, RHFont, RHForms, RHSpacing } from "../../Custom components/RH/Utils_slop/RHDesignTokens"
import type { RHContractingAuthorityType } from "../../SocketClientFunctions"


export class CompanyContractingAuthorityOptionView extends UIView {

    readonly checkbox = new RHCheckbox().addedAsSubviewToView(this)

    readonly thresholdLabel = new UITextView().configuredWithObject({
        textColor: RHColors.textSecondary,
        isSingleLine: NO,
        style: { fontSize: RHFont.sizeSmall }
    }).addedAsSubviewToView(this)


    constructor(readonly authorityType: RHContractingAuthorityType) {
        super()
        const definition = RHContractingAuthorityRules.definitions[authorityType]
        this.checkbox.titleLabel.configureWithObject({
            text: definition.title,
            style: { fontWeight: RHFont.weightMedium }
        })
        if (definition.goodsAndServicesThreshold !== undefined && definition.worksThreshold !== undefined) {
            this.thresholdLabel.text =
                `Asjad ja teenused ${definition.goodsAndServicesThreshold.toLocaleString("et-EE")} € · ` +
                `Ehitustööd ${definition.worksThreshold.toLocaleString("et-EE")} €`
        }
        else {
            this.thresholdLabel.text = "CPV-summeerimist ja piirmäära kontrolli ei kohaldata."
        }
    }


    override layoutSubviews() {
        super.layoutSubviews()
        const bounds = this.contentBoundsWithInset(RHSpacing.small)
        const labelLeadingInset = RHForms.checkboxControlLeadingInset + RHForms.checkboxControlSize +
            RHForms.checkboxControlGap + parseFloat(RHForms.checkboxLabelMarginLeft)
        bounds
            .rectangleWithHeight(Math.max(
                RHForms.checkboxControlSize,
                this.checkbox.titleLabel.intrinsicContentHeight(bounds.width - labelLeadingInset)
            ))
            .assignedAsFrameOfView(this.checkbox)
            .rectangleWithInsets(labelLeadingInset, 0, 0, 0)
            .rectangleForNextRow(RHSpacing.tiny, this.thresholdLabel)
            .assignedAsFrameOfView(this.thresholdLabel)
    }
}
